module.exports = __webpack_public_path__ + "img/uni_emirate_arab.10dc60d2.svg";